import type { Editor } from '@tiptap/vue-3'
import type { Ref } from 'vue'

export interface ArticleEditorToolbarAction {
  icon: string
  isActive: boolean
  label: string
  run: () => void
}

export const useArticleEditorToolbar = (editor: Ref<Editor | undefined>) => {
  const toolbarActions = computed<ArticleEditorToolbarAction[]>(() => {
    const editorInstance = editor.value
    if (!editorInstance) {
      return []
    }

    return [
      {
        icon: 'fa-bold',
        label: 'Bold',
        isActive: editorInstance.isActive('bold'),
        run: () => {
          editorInstance.chain().focus().toggleBold().run()
        },
      },
      {
        icon: 'fa-italic',
        label: 'Italic',
        isActive: editorInstance.isActive('italic'),
        run: () => {
          editorInstance.chain().focus().toggleItalic().run()
        },
      },
      {
        icon: 'fa-underline',
        label: 'Underline',
        isActive: editorInstance.isActive('underline'),
        run: () => {
          editorInstance.chain().focus().toggleUnderline().run()
        },
      },
      {
        icon: 'fa-strikethrough',
        label: 'Strikethrough',
        isActive: editorInstance.isActive('strike'),
        run: () => {
          editorInstance.chain().focus().toggleStrike().run()
        },
      },
      {
        icon: 'fa-link',
        label: 'Link',
        isActive: editorInstance.isActive('link'),
        run: () => {
          const previousUrl = editorInstance.getAttributes('link').href
          // eslint-disable-next-line no-alert
          const url = window.prompt('URL', previousUrl)
          if (url === null) {
            return
          }
          if (url === '') {
            editorInstance.chain().focus().extendMarkRange('link').unsetLink().run()
            return
          }
          editorInstance.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
        },
      },
      {
        icon: 'fa-list-ul',
        label: 'Bullet list',
        isActive: editorInstance.isActive('bulletList'),
        run: () => {
          editorInstance.chain().focus().toggleBulletList().run()
        },
      },
      {
        icon: 'fa-list-ol',
        label: 'Ordered list',
        isActive: editorInstance.isActive('orderedList'),
        run: () => {
          editorInstance.chain().focus().toggleOrderedList().run()
        },
      },
    ]
  })

  return {
    toolbarActions,
  }
}
